import { useState, useEffect } from "react";
import { calcTimeDelta } from "react-countdown";

import {
  extractDeviceColorOptions,
  extractProductList,
  isDoubleDealDevice,
} from "utils/dealDetails";

import badges from "../config/badges";
import labels from "../config/labels";
import types from "../config/types";
import { infinityStatuses } from "../config/infinityStatuses";
import { MOBILE_WIDTH } from "../config/constants";
import RouteLinks from "../config/routes";
import { Cookie } from "../components/atoms/DependencyHelper";
import ajaxService from "../utils/ajaxServices";
import { guestCreateEmptyCart, getCustomerActiveCart } from "../config/queries";
import { Logger } from "./logger";

const config = require("../config/index");

const env = config.env;
const server = config.envConfigs[env].server;
const configUrl = `${server}`;
export const imagePrefix = config.envConfigs[env].imagePrefix;
export const urlPrefix = config.envConfigs[env].shoppingUrlPrefix;
export const countryCode = "27";

export const cartUpdateEvent = () => {
  if (typeof refreshMenuState === "function") {
    // eslint-disable-next-line no-undef
    refreshMenuState();
  }
};

// TODO: Redundant. Please replace all uses with redux SET_IS_LOADING
export const showSpinner = () => {
  document.body.classList.add("no-scroll");
  var element = document.getElementById("loaderMain");
  if (element) {
    element.classList.add("showspin");
  }
};

// TODO: Redundant. Please replace all uses with redux SET_IS_LOADING
export const hideSpinner = () => {
  document.body.classList.remove("no-scroll");
  var element = document.getElementById("loaderMain");
  if (element) {
    element.classList.remove("showspin");
  }
};

export const valOrNull = (val) => val || null;
export const isDefined = (variable) => {
  return typeof variable !== "undefined";
};

export const getSessionStorage = (key) => {
  return isDefined(sessionStorage) && sessionStorage.getItem(key)
    ? JSON.parse(sessionStorage.getItem(key))
    : null;
};

export const updateSessionStorage = (key, value, notStringify = true) => {
  return (
    isDefined(sessionStorage) &&
    sessionStorage.setItem(key, notStringify ? JSON.stringify(value) : value)
  );
};

export const deleteSessionStorage = (key) => {
  return isDefined(sessionStorage) && sessionStorage.removeItem(key);
};

export const getCookieValue = (value) => {
  let cartCookie;
  cartCookie = Cookie.get(`${value}`);
  if (cartCookie) {
    return cartCookie;
  }
};

export const getProfileData = () => {
  let profileData = getSessionStorage("profile_data");
  if (profileData) {
    profileData = JSON.parse(profileData);
    profileData = profileData?.result?.profileSubscriptionResponse?.profile;

    if (profileData.profileId) {
      return profileData;
    } else {
      return null;
    }
  } else {
    return null;
  }
};

export const handleCartActionFailure = async (
  errorCode,
  cartAction = () => {},
  loggedInAction = () => {}
) => {
  const JWTtoken = getCookieValue("vod-web-auth-token");
  const authtoken = getCookieValue("auth_token");

  if (JWTtoken) {
    if (
      errorCode?.errors?.[0]?.message.includes(
        labels.lbl_current_user_cannot_perform_operation_on_cart
      )
    ) {
      loggedInAction();
    } else if (
      errorCode?.errors?.[0]?.message.includes(
        labels.lbl_could_not_find_cart_id
      )
    ) {
      Cookie.remove("cart_id");
      if (authtoken) {
        const cartId = await getCustomerActiveCartService();

        if (cartId && !cartId.fail && cartId.length) {
          setCookieConsentWrapper(
            "cart_id",
            [config.cookie_category.strictly_necessary],
            `document.cookie='cart_id=${cartId};path=/'`
          );
          cartAction();
        } else {
          loggedInAction();
        }
      } else {
        loggedInAction();
      }
    }
  } else {
    //guestUser
    Cookie.remove("cart_id");
    Cookie.remove("auth_token");

    const emptyCartForGuest = await ajaxService.fetchGraphQLPOSTRequest(
      guestCreateEmptyCart
    );
    const newCartId = emptyCartForGuest?.createEmptyCart;
    if (newCartId) {
      updateCartExpiry(newCartId);
      cartAction();
    }
  }
};

export const getCustomerActiveCartService = async () => {
  try {
    const result = await ajaxService.fetchGraphQLPOSTRequest(
      getCustomerActiveCart
    );
    let activeCartId;

    if (result && result.customerCart && result.customerCart.id) {
      activeCartId = result.customerCart.id;
    } else {
      activeCartId = "";
    }

    return activeCartId;
  } catch (error) {
    return { fail: true, error };
  }
};

export const getAuthToken = (dataResult) => {
  const oAuthToken =
    dataResult?.payload?.result?.magentoProfileResponse[0]?.OAuthTokenDetails[0]
      ?.OAuthToken;

  setCookieConsentWrapper(
    "auth_token",
    [config.cookie_category.strictly_necessary],
    `document.cookie='auth_token=${oAuthToken};path=/'`
  );
  return oAuthToken;
};

export const logOutUser = () => {
  Cookie.remove("vod-web-auth-token", { path: "/", domain: ".vodacom.co.za" });
  Cookie.remove("cart_id");
  Cookie.remove("auth_token");
  Cookie.remove("guest_checkout");
};

export const removeCartId = () => {
  Cookie.remove("cart_id");
};

export const clearUserToken = () => {
  Cookie.remove("vod-web-auth-token", {
    path: "/",
    domain: ".vodacom.co.za",
  });
  Cookie.remove("auth_token");
  Cookie.remove("cart_id");
};

export const isGuestCheckout = () => {
  let guestCookie = getCookieValue("guest_checkout");
  return guestCookie ? true : false;
};

export const setGuestCheckout = () => {
  let guestCookie = getCookieValue("guest_checkout");
  if (guestCookie === undefined) {
    setCookieConsentWrapper(
      "guest_checkout",
      [config.cookie_category.strictly_necessary],
      `document.cookie='guest_checkout=${true};path=/'`
    );
  }
};

export const updateCartExpiry = (cartIdentifier) => {
  const persistTime = getCookieValue("persist_time");
  const authtoken = getCookieValue("auth_token");
  const cartId = cartIdentifier ? cartIdentifier : getCookieValue("cart_id");
  let expiryTime = parseInt(persistTime) / 3600 / 24;

  if (!authtoken && cartId) {
    setCookieConsentWrapper(
      "cart_id",
      [config.cookie_category.strictly_necessary],
      `document.cookie='cart_id=${cartId}; expires=${expiryTime};path=/'`
    );
  }
};

export const componentResize = () => {
  const [isMobile, setIsMobile] = useState(false);
  let checkSize = false;
  useEffect(() => {
    if (typeof window !== undefined) {
      if (!checkSize) {
        updateWidthAndHeight();
        checkSize = true;
      }
      window.addEventListener("resize", updateWidthAndHeight);
      return () => window.removeEventListener("resize", updateWidthAndHeight);
    }
  }, []);

  const updateWidthAndHeight = () => {
    if (window.outerWidth <= MOBILE_WIDTH) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };
  return isMobile;
};

export const getNestedObjectValue = (nestedObj, pathArr) => {
  return pathArr.reduce(
    (obj, key) => (obj && obj[key] !== "undefined" ? obj[key] : null),
    nestedObj
  );
};

export const createMarkup = (htmlString) => {
  return { __html: htmlString };
};

export const roundUptwoDecimal = (val) => val.toFixed(2);

export const equalsIgnoreCase = (string, compareString) => {
  return string.toUpperCase() === compareString.toUpperCase();
};

export const capitalizeString = (text) =>
  text
    .toLowerCase()
    .split(" ")
    .map((string) => string.charAt(0).toUpperCase() + string.substring(1))
    .join(" ");

export const getBadgeName = (value) => {
  value = value?.toString().toLowerCase();
  const _badges = Object.keys(badges);
  if (_badges.indexOf(`${value}`) >= 0) return badges[`${value}`];
  else return `${value}`;
};

export const getTagName = (value) => {
  value = value?.match(/[^ ,]+/g)?.join("-");
  return value;
};

export const numberFormat = (value) =>
  new Intl.NumberFormat("en-IN").format(value);

export const numberToLocaleString = (value) => parseInt(value).toLocaleString();

export const checkIsLowStock = (item) => {
  if (item?.quantity === null) {
    return false;
  }
  return item?.quantity < item?.low_stock_threshold;
};

export const checkDealOutOfStock = (item) => {
  if (item?.__typename === labels.lbl_product_type_bundle) {
    if (item?.stock_status === labels.lbl_out_of_stock) {
      return true;
    }
    for (let i = 0; i < item?.items?.length; i++) {
      const itemOption = item.items[i];
      for (let j = 0; j < itemOption?.options?.length; j++) {
        const option = itemOption?.options[j];
        if (
          option?.product?.quantity !== null &&
          option?.product?.quantity <= 0 &&
          option?.product?.stock_status === labels.lbl_out_of_stock
        ) {
          return true;
        }
      }
    }
    return false;
  }
  return false;
};

export const checkStockQuantity = (item) => {
  switch (item?.__typename) {
    case labels.lbl_product_type_bundle: {
      for (let i = 0; i < item?.items?.length; i++) {
        const itemOption = item.items[i];
        for (let j = 0; j < itemOption?.options?.length; j++) {

          if (itemOption?.options[j].is_default) {
            const option = itemOption?.options[j].product?.variants;
            for (let k = 0; k < option.length; k++) {
              if (
                option?.product?.quantity !== null &&
                option?.product?.quantity <= 0
              ) {
                return true;
              }
            }
          }
          else {
            const option = itemOption?.options[j];
            if (
              option?.product?.quantity !== null &&
              option?.product?.quantity <= 0
            ) {
              return true;
            }
          }
        }
      }
      return false;
    }
    case labels.lbl_product_typeName_simple: {
      return item?.quantity !== null && item?.quantity <= 0;
    }
    case labels.lbl_product_typeName_configurable: {
      const flag =
        item.variants &&
        item.variants.length > 0 &&
        item.variants.every(
          (variant) =>
            variant?.product?.stock_status === labels.lbl_out_of_stock ||
            (variant?.product?.quantity !== null &&
              variant?.product?.quantity <= 0)
        );
      return flag;
    }
    default:
      return false;
  }
};

export const checkIsOutOfStock = (cartItem) => {
  const item = cartItem?.product || cartItem;
  const selectedVariant = cartItem?.configurable_options;

  if (
    item?.__typename === labels.lbl_product_type_bundle &&
    item?.stock_status === labels.lbl_out_of_stock
  ) {
    return true;
  } else if (item?.__typename === labels.lbl_product_typeName_simple) {
    return (
      (item &&
        item.stock_status &&
        item.stock_status === labels.lbl_out_of_stock) ||
      item?.quantity === 0
    );
  } else if (item?.__typename === labels.lbl_product_typeName_configurable) {
    const flag = checkEachVariantStock(selectedVariant, item);
    return flag;
  } else {
    return false;
  }
};

const checkEachVariantStock = (configurableOptions, item) => {
  try {
    const selectedConfigurableOptions = configurableOptions.map(
      (selectedItem) => selectedItem.value_id
    );
    let getSelectedVariant = item.variants.map((variantItem) => {
      const selectedVariant = variantItem.attributes.filter((vItem) => {
        return selectedConfigurableOptions.some((sItem) => {
          return sItem === vItem.value_index;
        });
      });

      if (selectedVariant.length === selectedConfigurableOptions.length) {
        return variantItem;
      }
    });

    getSelectedVariant = getSelectedVariant.filter(
      (item) => item !== undefined
    );
    if (getSelectedVariant.length) {
      return getSelectedVariant.every((variant) => {
        if (variant) {
          return (
            variant?.product?.stock_status === labels.lbl_out_of_stock ||
            variant?.product?.quantity <= 0
          );
        }
      });
    }
  } catch (error) {
    return false;
  }

  return false;
};

const getColorSelectionIds = (bundleCustomisableOption) => {

  if (!Array.isArray(bundleCustomisableOption)) {
    return [];
  }

  const colorSelections = bundleCustomisableOption.reduce((acc, option) => {
    const selectedAttr = isValidJSON(option.selected_attribute)
      ? JSON.parse(option.selected_attribute)
      : null;
    const attrIds = selectedAttr?.value.indexOf(',') > 0
      ? selectedAttr?.value.split(",")
      : [selectedAttr?.value]

    const optionsFormatted = attrIds.map(attrId => ({
      attributeId: selectedAttr?.name,
      productOptionId: option?.attribute_option_id,
      colorId: attrId,
    }));

    return [...acc, ...optionsFormatted];
  }, []);

  return colorSelections;
}

const extractColorSelections = (dealDetailsItem) => {

  if (!dealDetailsItem?.bundle_customisable_option) {
    return {};
  }

  const products = extractProductList(dealDetailsItem?.product);

  const isDoubleDeal = isDoubleDealDevice(products);
  const colorSelections = getColorSelectionIds(dealDetailsItem?.bundle_customisable_option);

  const primaryDevice = products.find(product => product.isPrimary);
  const primaryColorSelectionIndex = colorSelections.findIndex(cs => cs.productOptionId === primaryDevice?.optionId);
  const primaryColorSelection = colorSelections.splice(primaryColorSelectionIndex, 1)[0];

  const colorOptions = extractDeviceColorOptions(primaryDevice)
  const colorSelection = Array.isArray(colorOptions)
    ? colorOptions.find(clo => clo.id === Number(primaryColorSelection?.colorId))
    : null;

  let secondaryDevice = null;
  let colorSelectionSecondary = null;

  if (isDoubleDeal) {
    secondaryDevice = products.find((product) => product.isSecondary || product.optionQuantity > 1);
    
    const secondaryColorSelection = colorSelections.find(cs => cs.productOptionId === secondaryDevice?.optionId);

    const secondaryColorOptions = extractDeviceColorOptions(secondaryDevice);

    colorSelectionSecondary = Array.isArray(secondaryColorOptions)
      ? secondaryColorOptions.find(clo => clo.id === Number(secondaryColorSelection?.colorId))
      : null;
  }

  return {
    colorSelection_primary: colorSelection,
    colorSelection_secondary: colorSelectionSecondary,
    isDoubleDeal,
  };
}

export const checkVarientInStock = (item, selectedVarient) => {
  if (item?.__typename === labels.lbl_product_type_bundle) {
    for (let i = 0; i < item?.items?.length; i++) {
      const itemOption = item.items[i];
      for (let j = 0; j < itemOption?.options?.length; j++) {
        if (itemOption?.options[j].is_default) {
          const option = itemOption?.options[j].product?.variants ? itemOption?.options[j].product?.variants : [];
          for (let k = 0; k < option?.length; k++) {
            if (
              option[k]?.attributes[0]?.value_index === parseInt(selectedVarient) &&
              option[k]?.product?.quantity !== null &&
              option[k]?.product?.quantity <= 0
            ) {
              return true;
            }
          }
        }
      }
    }
  }
}

export const mapCartProductItems = (cartProductItems) => {
  return (cartProductItems || [])
    .filter((item) => {
      return item && item !== null;
    })
    .map((item) => {
      const isDealProduct = !!item?.product?.is_deal_product;
      const isOutOfStock = isDealProduct
        ? checkDealOutOfStock(item?.product)
        : checkIsOutOfStock(item);
      const selected_attribute = isValidJSON(item?.bundle_customisable_option?.selected_attribute)
        ? JSON.parse(item?.bundle_customisable_option?.selected_attribute)
        : "";
      const hasBackOrderLabel = checkVarientInStock(item?.product, selected_attribute.value)
      const {
        colorSelection_primary = null,
        colorSelection_secondary = null,
        isDoubleDeal = false
      } = extractColorSelections(item);
      const hasPreOrderLabel = item?.product?.promotion_tag_label === types.TYPE_PREORDER;

      return {
        ...item,
        isDealProduct,
        isOutOfStock,
        isLowStock: checkIsLowStock(item),
        hasBackOrderLabel: isDealProduct && !isOutOfStock && hasBackOrderLabel,
        hasPreOrderLabel,
        badgesLabel: item?.product?.promotion_tag_label,
        colorSelection: colorSelection_primary,
        colorSelectionSecondary: colorSelection_secondary,
        isDoubleDeal,
        __typename: item?.product?.__typename,
      };
    });
};

const isOnceOffProductOrder = (item) => {
  return (
    (item?.product?.is_deal_product === 0 || !item?.product?.is_deal_product) &&
    (!item?.parent_product_sku ||
      item?.parent_product_sku === "" ||
      item?.parent_product_sku === null)
  );
};

export const validateOrderItems = (items) => {
  const orders = items || [];
  const resp = {
    isMulti: false,
    onceOff: orders.some((i) => !i?.isDealProduct && isOnceOffProductOrder(i)),
    onceOffMissed: orders.some((i) => !i?.isDealProduct && i?.isOutOfStock),
    contract: orders.some((i) => i?.isDealProduct),
    contractMissed: orders.some((i) => i?.isDealProduct && i?.isOutOfStock),
    hasPreOrder: orders.some((i) => i?.hasPreOrderLabel),
    hasBackOrder: orders.some((i) => i?.hasBackOrderLabel),
  };

  if (resp.contract && resp.onceOff) {
    resp.isMulti = true;
  }

  return resp;
};

export const splitCartItems = (cartItems) => {
  return {
    dealCartProducts: cartItems.filter(
      (item) => item?.product?.is_deal_product === 1
    ),
    onceOffCartProducts: cartItems.filter(isOnceOffProductOrder),
  };
};

export const checkIsFinalPriceReq = (item) => {
  return item &&
    item.price_range &&
    item.price_range.minimum_price &&
    item.price_range.minimum_price.discount &&
    item.price_range.minimum_price.discount.amount_off &&
    item.price_range.minimum_price.discount.amount_off !== "0"
    ? true
    : false;
};

export const getRegularPrice = (item) => {
  return item &&
    item.price_range &&
    item.price_range.minimum_price &&
    item.price_range.minimum_price.regular_price &&
    item.price_range.minimum_price.regular_price.value
    ? item.price_range.minimum_price.regular_price.value
    : "0";
};

export const getFinalPrice = (item) => {
  return item &&
    item.price_range &&
    item.price_range.minimum_price &&
    item.price_range.minimum_price.final_price &&
    item.price_range.minimum_price.final_price.value
    ? item.price_range.minimum_price.final_price.value
    : "0";
};

export const getPercentOffValue = (item) => {
  return item &&
    item.price_range &&
    item.price_range.minimum_price &&
    item.price_range.minimum_price.discount &&
    item.price_range.minimum_price.discount.percent_off
    ? item.price_range.minimum_price.discount.percent_off
    : "0";
};

export const getAmountOffValue = (item) => {
  return item &&
    item.price_range &&
    item.price_range.minimum_price &&
    item.price_range.minimum_price.discount &&
    item.price_range.minimum_price.discount.amount_off
    ? item.price_range.minimum_price.discount.amount_off
    : "0";
};

export const checkDomain = (url) => {
  if (url.indexOf("//") === 0) {
    url = location?.protocol + url;
  }
  return url
    .toLowerCase()
    .replace(/([a-z])?:\/\//, "$1")
    .split("/")[0];
};

export const isExternalUrl = (url) => {
  return (
    url.indexOf(":") > -1 &&
    url.indexOf("//") > -1 &&
    checkDomain(location?.href) !== checkDomain(url)
  );
};

export const goToUrl = (url, router, newTab = "") => {
  if (newTab && newTab === "1") {
    if (typeof window !== undefined) {
      window.open(url, "_blank");
    }
  } else if (isExternalUrl(url)) {
    window.open(url, "_blank");
  } else {
    showSpinner();
    if (checkDomain(location?.href) == checkDomain(url)) {
      let newURL = url.split(window.location?.host)[1];
      router.push(newURL).then(() => {
        window.scrollTo(0, 0);
        hideSpinner();
      });
    } else {
      router.push(url).then(() => {
        window.scrollTo(0, 0);
        hideSpinner();
      });
    }
  }
};

export const getUrlPath = (url) => {
  return isExternalUrl(url) ? url : new URL(url).pathname;
};

export const internalUrl = (url) => {
  if (url && url.includes("internal:")) {
    if (url.includes("internal:/shopping")) {
      return {
        url: url.split("internal:")[1],
        internal: true,
      };
    } else {
      try {
        const host = configUrl.split("/shopping")[0];
        const newUrl = `${host}${url.split("internal:")[1]}`;
        return { url: newUrl, internal: false };
      } catch (e) {
        Logger.error(e);
        console.log("error", e);
      }
    }
  }
  return { url, internal: false };
};

export const isDiscountTimerApplicable = (promotion) => {
  if (promotion && promotion.start_date && promotion.start_date !== "")
    return (new Date(promotion.start_date.replace(" ", "T")) <= new Date()
        || new Date(promotion.start_date.replace(/-/g, "/")) <= new Date()
      ) && (new Date(promotion.end_date.replace(" ", "T")) >= new Date()
        || new Date(promotion.end_date.replace(/-/g, "/")) >= new Date()
      );
  return false;
};

export const replaceValue = (str, search, replace) => {
  str = str.replace(search, replace);
  return str;
};

export const setRoutes = (value) => {
  return isDefined(sessionStorage) && updateSessionStorage("routes", value);
};

export const dynamicBreadCrumb = () => {
  const [pageHistory, setPageHistory] = useState(null);
  useEffect(() => {
    setPageHistory(getSessionStorage(labels.Session_Keys.lbl_breadCrumb));
  }, [pageHistory?.prevPageName]);
  return formatBreadCrumbAsList(pageHistory?.history, pageHistory?.routes);
};

export const formatBreadCrumbAsList = (crumb) => {
  let list = {};
  let breadCrumbArr = [];
  crumb &&
    crumb.forEach((page) => {
      const pagePathName =
        page?.pathname === "/"
          ? page.pathname
          : "/shopping" + page?.pathname?.split("/shopping")[1];
      const pageLink = page.pathname.includes("shopping/products")
        ? getSessionStorage(
            labels.Session_Keys.lbl_list_page_router_with_filters
          )
        : page.asPath;
      const matchedRoute = RouteLinks.filter(
        (route) => pagePathName == route.url
      );
      if (matchedRoute.length) {
        list[page.replaceTitle ? page.replaceTitle : matchedRoute[0].title] = {
          url: pageLink,
        };
      } else {
        const routes = getSessionStorage("routes");
        if (routes?.length) {
          const matchedRoute = routes.filter(
            (route) => pagePathName == route.url
          );
          if (matchedRoute.length) {
            list[
              page.replaceTitle ? page.replaceTitle : matchedRoute[0].title
            ] = { url: pageLink };
          }
        }
      }
      breadCrumbArr.push(list);
    });
  return list;
};

export const formatBreadCrumb = (crumb) => {
  let list = {};
  let breadCrumbArr = [];
  crumb &&
    crumb.forEach((page) => {
      list[page.label] = { url: page.link };
      breadCrumbArr.push(list);
    });
  return list;
};

export const formatNumbersWithComma = (number) =>
  Number(parseFloat(number).toFixed(2)).toLocaleString("en-US", {
    minimumFractionDigits: 2,
  });

export const componentCheckSize = () => {
  const [windowWidth, setWindowWidth] = useState();

  let checkSize = false;
  useEffect(() => {
    if (typeof window !== undefined) {
      if (!checkSize) {
        updateWidthAndHeight();
        checkSize = true;
      }
      window.addEventListener("resize", updateWidthAndHeight);
      return () => window.removeEventListener("resize", updateWidthAndHeight);
    }
  }, []);

  const updateWidthAndHeight = () => {
    setWindowWidth(window.innerWidth);
  };

  return windowWidth;
};

export const formatBytes = (a, b = 2) => {
  if (0 === a) return "0 Bytes";
  const c = 0 > b ? 0 : b,
    d = Math.floor(Math.log(a) / Math.log(1000));
  return (
    parseFloat((a / Math.pow(1000, d)).toFixed(c)) +
    ["MB", "GB", "TB", "PB", "EB", "ZB", "YB"][d]
  );
};

export const getHighlights = (item) => {
  const highlights = [
    { id: "1", value: "", displayUnit: "data", unit: "promo_data" },
    { id: "2", value: "", displayUnit: "voice minutes", unit: "minutes_label" },
    { id: "3", value: "", displayUnit: "airtime", unit: "airtime" },
    { id: "4", value: "", displayUnit: "sms", unit: "sms" },
  ];
  highlights.forEach((highlight) => {
    highlight.value = item[highlight.unit];
  });
  const newHighlight = highlights.filter((item) => {
    if (item.value > 0 || item.value == "Unlimited") {
      return item;
    }
  });
  const dataIndex = newHighlight.findIndex(
    (highLight) => highLight.unit === "promo_data"
  );
  if (dataIndex >= 0) {
    newHighlight[dataIndex].value = formatBytes(newHighlight[dataIndex].value);
  }
  const airtimeIndex = newHighlight.findIndex(
    (highLight) => highLight.unit === "airtime"
  );
  if (airtimeIndex >= 0) {
    newHighlight[airtimeIndex].value = `R${newHighlight[airtimeIndex].value}`;
  }
  return newHighlight;
};

export const getSpecs = (deviceData) => {
  const specTypes = [
    {
      id: "1",
      value: "",
      displayLabel: "Storage Size",
      label: "internal_storage_label",
    },
    {
      id: "2",
      value: "",
      displayLabel: "Colour",
      label: "color_label",
    },
    {
      id: "3",
      value: "",
      displayLabel: "Screen Size Pixels",
      label: "screen_size_pixels_label",
    },
    {
      id: "4",
      value: "",
      displayLabel: "Battery Capacity",
      label: "battery_capacity_label",
    },
    {
      id: "5",
      value: "",
      displayLabel: "Size",
      label: "size_label",
    },
  ];

  specTypes.forEach((highlight) => {
    highlight.value = deviceData[highlight.label];
  });
  const newHighlight = specTypes.filter((item) => {
    if (item.value) {
      return item;
    }
  });
  return newHighlight;
};

export const requestType = (api) => {
  if (api.method === "GET") {
    return api.apiEndpoint;
  } else {
    return api.requestBody;
  }
};

export const getRequestBody = (api) => {
  let requestBody = "";
  if (api.method) {
    requestBody = requestType(api);
  } else {
    requestBody = requestType(api.single);
  }
  return requestBody;
};

export const convertToCorrectDateFormat = (dateTime) => {
  if (dateTime) {
    return dateTime.replace(/-/g, "/");
  } else return "";
};

export const getdealDatenVariant = (props) => {
  const dealLocked = props.is_deal_locked;
  let dateTime = "";
  let dealVariant = "";
  let isCrntTimeGrtr = 0;
  const deal_go_live_date = convertToCorrectDateFormat(props.deal_go_live_date);
  const deal_end_date = convertToCorrectDateFormat(props.deal_end_date);

  if (deal_go_live_date && new Date() > new Date(deal_go_live_date)) {
    isCrntTimeGrtr = 1;
  }
  if (dealLocked == 1 && deal_go_live_date && isCrntTimeGrtr == 0) {
    dealVariant = "locked";
    dateTime = deal_go_live_date;
  } else if (
    dealLocked == 0 &&
    deal_go_live_date &&
    deal_end_date == "" &&
    isCrntTimeGrtr == 0
  ) {
    dealVariant = "hidden";
    dateTime = deal_go_live_date;
  } else if (dealLocked === 0 && deal_go_live_date && isCrntTimeGrtr === 0) {
    dealVariant = "comingSoon";
    dateTime = deal_go_live_date;
  } else if (dealLocked == 0 && deal_end_date != "" && isCrntTimeGrtr == 1) {
    if (new Date() > new Date(deal_end_date)) {
      dealVariant = "Expired";
      dateTime = deal_end_date;
    } else {
      dealVariant = "specialDeals";
      dateTime = deal_end_date;
    }
  }

  return [dateTime, dealVariant];
};

export const getDealExpiryTime = (dealEndTime) => {
  let deal_expiry = calcTimeDelta(dealEndTime);
  return `${deal_expiry?.days}d ${deal_expiry?.hours}h ${deal_expiry?.minutes}m ${deal_expiry?.seconds}s`;
};

export const getPromotionLabel = (item) => {
  if (item?.badges_label) {
    return item.badges_label;
  } else if (item?.promotion_tag_label) {
    return item.promotion_tag_label;
  } else {
    return "";
  }
};

export const getPromotionVariant = (item) => {
  if (item?.badges_label) {
    return getTagName(item.badges_label);
  } else if (item?.promotion_tag_label && item.promotion_tag_label.length > 1) {
    return getTagName(item.promotion_tag_label);
  } else {
    return "";
  }
};

export const getPlanNameLabel = (item) => {
  if (item.items && item.items.length >= 1) {
    const items = item.items;
    const plan = items.filter((item) => item.title === "Promo");
    if (plan.length && plan[0]?.options?.length) {
      return `on ${plan[0].options[0].product?.name} with:`;
    } else if (item?.plan_name_label) {
      return `on ${item.plan_name_label} with:`;
    } else {
      return "";
    }
  } else if (item?.plan_name_label) {
    return `on ${item.plan_name_label} with:`;
  } else {
    return "";
  }
};

export const getColorHexVal = (colorLabel, configOptions) => {
  let hexval;
  configOptions?.filter((options) => {
    if (
      (options.label == "Color" || options.attribute_code == "color") &&
      options.values.length
    ) {
      const matchedColor = options.values.find(
        (value) => value?.label?.toLowerCase() == colorLabel?.toLowerCase()
      );
      if (matchedColor && matchedColor?.swatch_data?.value) {
        hexval = matchedColor?.swatch_data?.value;
      }
    }
  });
  return hexval;
};

export const getCustomDate = (completeDate) => {
  const date = new Date(completeDate.replace(/-/g, "/"));
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  return (
    date.getDate() +
    " " +
    monthNames[date.getMonth()] +
    " " +
    date.getFullYear()
  );
};
export const getAllInStockMemoryAttributes = (variant, memory) => {
  let selectedMemoryVariants = [];
  if (variant?.length && memory.length) {
    memory.forEach((memory) => {
      variant.forEach((variant) => {
        if (variant && variant?.attributes?.length) {
          const memoryAttr = variant?.attributes?.filter(
            (val) =>
              (val.code == labels.lbl_internal_storage ||
                val.code == labels.lbl_Internal_Storage) &&
              memory.label == val.label
          );
          const isColorAttrPresent = variant?.attributes?.filter(
            (variant) =>
              variant.code == "color" && variant.label && variant.label !== ""
          );
          if (
            memoryAttr.length &&
            variant?.product?.stock_status === labels.lbl_in_stock &&
            ((selectedMemoryVariants.length &&
              selectedMemoryVariants.filter(
                (eachMemory) => eachMemory?.label === memory.label
              ).length === 0) ||
              selectedMemoryVariants.length === 0) &&
            isColorAttrPresent.length
          ) {
            selectedMemoryVariants.push(memory);
          }
        }
      });
    });
  }
  return selectedMemoryVariants;
};

export const setCookieConsentWrapper = (id, _categories = [], code) => {
  const el = document.getElementById(id);
  if (el) {
    el.parentNode.removeChild(el);
  }
  // const listCategories = _categories.join("-")
  const script = document.createElement("script");
  script.id = id;
  script.type = "text/javascript";
  // script.className = `optanon-category-${listCategories}`;
  script.text = code;
  document?.body?.appendChild(script);
};

export const removeCookieConsentWrapper = (scriptToremove) => {
  let allsuspects = document.getElementsByTagName("script");
  for (let i = allsuspects.length; i >= 0; i--) {
    if (
      allsuspects[i] &&
      allsuspects[i].getAttribute("src") !== null &&
      allsuspects[i].getAttribute("text").indexOf(`${scriptToremove}`) !== -1
    ) {
      allsuspects[i].parentNode.removeChild(allsuspects[i]);
    }
  }
};

export const useCookieConsentWrapper = (categories = [], code) => {
  const listCategories = categories.join("-");
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "text/plain";
    script.className = `optanon-category-${listCategories}`;
    script.text = code;
    document?.body?.appendChild(script);
    return () => {
      document?.body?.removeChild(script);
    };
  }, []);
};

export const getTrackingUrl = (trackingId, orderId) => {
  const orderParam = orderId ? `/${orderId}` : "";
  return `${urlPrefix}/${types.TRACK_MY_ORDER_PAGE}/${trackingId}${orderParam}`;
};

export const getOrderDetailUrl = (orderId) => {
  return `${urlPrefix}/${types.ORDER_DETAILS_PAGE}/${orderId}`;
};

export const getDealsGridUrl = () => {
  return `${urlPrefix}/${types.DEAL_GRID_PAGE}`;
};

export const getOrderTypeAndLabel = (statusCode) => {
  let orderStatusLabel = "";
  switch ((statusCode || "").toString().toUpperCase()) {
    case "CREATE_MAGENTO_SUCCESS":
    case "EPPIX_CREATE_TEMP_FAIL":
    case "CREATE_EPPIX_SUCCESS":
    case "CREATE_SUBMITTED_FAIL":
    case "CREATE_SUBMIT_SUCCESS":
    case "ZERO_VALUE_ORDER":
    case "PAYMENT_INIT_SUCCESS":
    case "PAYMENT_COMPLETE_SUCCESS":
    case "CQFD_SUBMIT_TEMP_FAIL":
    case "CQFD_SUBMIT_SUCCESS":
    case "CREATE_L500_FAILED":
    case "CREATE_L500_SUCCESS":
    case "UPDATE_L500_FAILED":
    case "UPDATE_L500_SUCCESS":
    case "UPDATE_EPPIX_FAILED":
    case "UPDATE_EPPIX_SUCCESS":
    case "PROCESSING":
    case "PENDING":
      orderStatusLabel = labels.order_status_labels.lbl_processing;
      break;
    case "CREATE_EPPIX_FAILED":
    case "EPPIX_CREATE_FAIL":
    case "FORM_ENCRYPTION_FAILED":
    case "PAYMENT_INIT_FAILED":
    case "CQFD_SUBMIT_FAIL":
    case "MULTI_PAYMENT_SETTLE_FAILED":
    case "PAYMENT_SETTLED_FAILED":
      orderStatusLabel = labels.order_status_labels.lbl_order_error;
      break;
    case "PAYMENT_COMPLETE_FAILED":
      orderStatusLabel = labels.order_status_labels.lbl_payment_failed;
      break;
    case "ORDER_COMPLETE_SUCCESS":
      orderStatusLabel = labels.order_status_labels.lbl_processed;
      break;
    case "PAYMENT_SETTLED_SUCCESS":
      orderStatusLabel = labels.order_status_labels.lbl_paid;
      break;
    case "CANCELED":
    case "PENDING ORDER COUNTDOWN ELAPSED":
      orderStatusLabel = labels.order_status_labels.lbl_cancelled;
      break;
  }
  return {
    productOrderState: statusCode,
    orderStatusLabel: orderStatusLabel,
  };
};

export const orderPageButtons = (statusCode) => {
  const { orderStatusLabel } = getOrderTypeAndLabel(statusCode);
  let displayTrackOrderBtn = false;
  let displayRetryOrderBtn = false;

  if (
    [
      labels.order_status_labels.lbl_paid,
      labels.order_status_labels.lbl_processing,
      labels.order_status_labels.lbl_processed,
    ].indexOf(orderStatusLabel) !== -1
  ) {
    displayTrackOrderBtn = true;
  }

  switch (statusCode) {
    case "CREATE_EPPIX_FAILED":
    case "FORM_ENCRYPTION_FAILED":
    case "PAYMENT_INIT_FAILED":
    case "PAYMENT_COMPLETE_FAILED":
      displayRetryOrderBtn = true;
      break;
  }
  return {
    displayTrackOrderBtn,
    displayRetryOrderBtn,
  };
};

export const getOrderBlurb = (statusCode) => {
  switch (statusCode) {
    case "CREATE_EPPIX_FAILED":
    case "FORM_ENCRYPTION_FAILED":
    case "PAYMENT_INIT_FAILED":
      return labels.order_blurb_labels.lbl_will_be_cancelled;
    case "PAYMENT_COMPLETE_FAILED":
      return labels.order_blurb_labels.lbl_retry_order;
    case "CQFD_SUBMIT_FAIL":
      return labels.order_blurb_labels.lbl_consultant_touch;
    case "MULTI_PAYMENT_SETTLE_FAILED":
    case "PAYMENT_SETTLED_FAILED":
      return labels.order_blurb_labels.lbl_settlement_failed;
    case "PAYMENT_SETTLED_SUCCESS":
      return labels.order_blurb_labels.lbl_payment_received;
  }
  return "";
};

export const getOrderMessage = (statusCode) => {
  switch (statusCode) {
    case "CREATE_EPPIX_FAILED":
    case "FORM_ENCRYPTION_FAILED":
    case "PAYMENT_INIT_FAILED":
    case "PAYMENT_COMPLETE_FAILED":
      return labels.order_messages_labels.lbl_will_be_cancelled;
    case "CQFD_SUBMIT_FAIL":
      return labels.order_messages_labels.lbl_consultant_touch;
    case "MULTI_PAYMENT_SETTLE_FAILED":
    case "PAYMENT_SETTLED_FAILED":
      return labels.order_messages_labels.lbl_settlement_failed;
    case "Pending order countdown elapsed":
      return labels.order_messages_labels.lbl_is_cancelled;
  }
  return "";
};

export const getOrderCreated = (statusCode) => {
  let status = false;
  switch (statusCode) {
    case "CREATE_MAGENTO_SUCCESS":
    case "CREATE_EPPIX_SUCCESS":
    case "CREATE_EPPIX_FAILED":
    case "FORM_ENCRYPTION_FAILED":
      status = true;
      break;
  }
  return status;
};

export const getOrderCancelled = (statusCode) => {
  return (
    getOrderTypeAndLabel(statusCode).orderStatusLabel ===
    labels.order_status_labels.lbl_cancelled
  );
};

export const generateOrderCSSVariant = (statusCode) => {
  const { orderStatusLabel } = getOrderTypeAndLabel(statusCode);
  if (
    [
      labels.order_status_labels.lbl_paid,
      labels.order_status_labels.lbl_processing,
    ].indexOf(orderStatusLabel) !== -1
  ) {
    return "order-status--processing";
  } else if (
    [labels.order_status_labels.lbl_processed].indexOf(orderStatusLabel) !== -1
  ) {
    return "order-status--processed";
  } else if (
    [
      labels.order_status_labels.lbl_order_error,
      labels.order_status_labels.lbl_payment_failed,
    ].indexOf(orderStatusLabel) !== -1
  ) {
    return "order-status--error";
  } else if (orderStatusLabel === labels.order_status_labels.lbl_cancelled) {
    return "order-status--cancelled";
  }
  return "order-status";
};

export const generateOrderIconVariant = (statusCode) => {
  const { orderStatusLabel } = getOrderTypeAndLabel(statusCode);
  if (
    [
      labels.order_status_labels.lbl_processing,
      labels.order_status_labels.lbl_paid,
    ].indexOf(orderStatusLabel) !== -1
  ) {
    return "sync.svg";
  } else if (
    [
      labels.order_status_labels.lbl_order_error,
      labels.order_status_labels.lbl_payment_failed,
    ].indexOf(orderStatusLabel) !== -1
  ) {
    return "warning.svg";
  } else if (orderStatusLabel === labels.order_status_labels.lbl_cancelled) {
    return "icon-cross.svg";
  } else if (orderStatusLabel === labels.order_status_labels.lbl_processed) {
    return "success-circle.svg";
  }
  return "success-circle-blue.svg";
};

export const getOrderInfinityStatus = (statusCode) => {
  const infinityStatus = statusCode.toString().toUpperCase();
  let status;
  status = infinityStatuses[infinityStatus]
    ? infinityStatuses[infinityStatus]
    : status;
  return status;
};

export const infinityArrayToObject = (arr) => {
  let newObject = {};
  (arr || []).forEach((item) => {
    newObject[item.schemeName] = item.value;
  });
  return newObject;
};

const checkOrderType = (orderTypes, orderType) => {
  return (
    (orderTypes || []).map((s) => s.toUpperCase()).indexOf(orderType) !== -1
  );
};

export const isOnceOffOrder = (orderTypes) =>
  checkOrderType(orderTypes, labels.lbl_once_off_purchase);

export const isMonthlyOrder = (orderTypes) =>
  checkOrderType(orderTypes, labels.lbl_monthly_purchase);

export const isUpgradeOrder = (orderTypes) =>
  checkOrderType(orderTypes, labels.lbl_upgrade_purchase);

export const isDealOrder = (orderTypes) =>
  isMonthlyOrder(orderTypes) || isUpgradeOrder(orderTypes);

export const isMultiOrder = (orderTypes) =>
  isDealOrder(orderTypes) && isOnceOffOrder(orderTypes);

export const getProductDetails = ({ ordered_product_details }) => {
  const [orderItemData] = ordered_product_details || [];
  const { product_details } = orderItemData || {};
  return product_details && typeof product_details === "string"
    ? JSON.parse(product_details)
    : product_details;
};

export const getDealPrice = (dealProductDetails) => {
  return `R${formatNumbersWithComma(
    dealProductDetails?.monthly_price || dealProductDetails?.monthly_recurring
  )} × ${
    dealProductDetails?.payment_terms_label ||
    dealProductDetails?.payment_terms ||
    ""
  }`;
};

export const getVasData = ({ items }) => {
  let dealVasProduct = [];
  items.forEach((item) => {
    if (item?.parent_product_sku !== null) {
      dealVasProduct.push(item);
    }
  });
  return dealVasProduct;
};

export const getVasDealPrice = (vasData, dealProductDetails) => {
  let dealVasPrice = 0;
  vasData.forEach((item) => {
    if (item?.parent_product_sku !== null) {
      dealVasPrice =
        parseFloat(dealVasPrice) + parseFloat(item?.monthly_recurring);
    }
  });
  dealVasPrice =
    parseFloat(dealVasPrice) +
    parseFloat(
      dealProductDetails?.monthly_price || dealProductDetails?.monthly_recurring
    );
  return `R${formatNumbersWithComma(dealVasPrice)} × ${
    dealProductDetails?.payment_terms_label ||
    dealProductDetails?.payment_terms ||
    ""
  }`;
};

export const getDisplayedRange = (itemsLoaded, totalItemsCount, text) => {
  const resultText = text || "results";
  return itemsLoaded > 0
    ? `1 - ${itemsLoaded} of ${totalItemsCount} ${resultText}`
    : `0 - 0 of 0 ${resultText}`;
};

export const getDisplayedRangeOnDealSelection = (
  itemsLoaded,
  itemOnCurrentPage,
  totalItems,
  text
) => {
  return totalItems > 0
    ? `${itemsLoaded} - ${itemOnCurrentPage} of ${totalItems} ${text}`
    : `0 - 0 of 0 ${text}`;
};

export const calculateShipping = (cartDetails) => {
  if (cartDetails && cartDetails.shippingFeeCalculate) {
    if (
      cartDetails.shippingFeeCalculate.shipping_fee == 0 &&
      cartDetails.shippingFeeCalculate.carrier_code == "freeshipping"
    ) {
      return cartDetails.shippingFeeCalculate.shipping_label
        ? cartDetails.shippingFeeCalculate.shipping_label
        : labels.lbl_free;
    } else {
      return `R${formatNumbersWithComma(
        Math.round(cartDetails.shippingFeeCalculate.shipping_fee * 100) / 100
      )}`;
    }
  } else {
    return null;
  }
};

export const updateBreadCrumbPageTitle = (page, titleToUpdate) => {
  let breadCrumbList = getSessionStorage(labels.Session_Keys.lbl_breadCrumb);
  breadCrumbList?.history?.forEach((bcrumb) => {
    if (bcrumb.pathname === page) {
      bcrumb["replaceTitle"] = titleToUpdate;
    }
  });
  updateSessionStorage(labels.Session_Keys.lbl_breadCrumb, breadCrumbList);
};

export const getCurrentPageNumber = (query) => {
  let filterCriteria = [];
  let params = query !== {} ? query.toString().split("?") : [];
  let filters = params && params.length > 1 ? params[1].split("&") : [];
  let pageNumber = 1;
  for (const item of filters) {
    filterCriteria = item.split("=");
    if (filterCriteria[0] === "currentPage") {
      pageNumber = filterCriteria[1];
    }
  }
  return parseInt(pageNumber);
};

export const getCurrentSortVal = (query, appendMonthly) => {
  let filterCriteria = [];
  let params = query !== {} ? query.toString().split("?") : [];
  let filters = params && params.length > 1 ? params[1].split("&") : [];
  let sortFilter = labels.sortKeys.lbl_recommended;
  for (const item of filters) {
    filterCriteria = item.split("=");
    if (filterCriteria[0] === "sortBy") {
      sortFilter = filterCriteria[1];
    }
  }

  if (query.toString().indexOf("monthlyPrice") !== -1) {
    switch (decodeURI(sortFilter)) {
      case labels.sortKeys.lbl_low_to_high:
        return appendMonthly
          ? labels.priceFilter.monthly_lbl_low_to_high
          : labels.sortKeys.lbl_low_to_high;
      case labels.sortKeys.lbl_high_to_low:
        return appendMonthly
          ? labels.priceFilter.monthly_lbl_high_to_low
          : labels.sortKeys.lbl_high_to_low;
      default:
        return decodeURI(sortFilter);
    }
  }
  return decodeURI(sortFilter);
};

export const updatePathInBreadCrumb = (route) => {
  let breadCrumbList = getSessionStorage(labels.Session_Keys.lbl_breadCrumb);
  breadCrumbList?.history?.forEach((bcrumb) => {
    if (bcrumb.asPath === route.asPath || bcrumb.pathname === route.pathname) {
      bcrumb["asPath"] = route.asPath;
    }
  });
  updateSessionStorage(labels.Session_Keys.lbl_breadCrumb, breadCrumbList);
};

export const getUpdatedSurname = (surname) => {
  let surName = surname?.toLowerCase() === "no last name" ? "" : surname;
  return surName;
};

export const getUpdatedContactPerson = (contactdetail) => {
  return contactdetail?.replace(/no last name/gi, "");
};
export const isArrayNotEmpty = (array) => {
  return array && Array.isArray(array) && array.length > 0;
};

export const getProductsCookie = (cookieSkuArr, products) => {
  let data = [];
  if (isArrayNotEmpty(cookieSkuArr) && isArrayNotEmpty(products)) {
    cookieSkuArr &&
      cookieSkuArr.forEach((skudata) => {
        products &&
          products.forEach((productIterator) => {
            if (productIterator.sku === skudata.sku) {
              const obj = {
                sku: productIterator.sku,
                name: productIterator.name,
                price_range: productIterator.price_range,
                image: productIterator.image,
                badges_label: productIterator.badges_label,
                display_low_stock_badge:
                  productIterator.display_low_stock_badge,
                quantity: productIterator.quantity,
                low_stock_threshold: productIterator.low_stock_threshold,
                stock_status: productIterator.stock_status,
                __typename: productIterator.__typename,
                options: productIterator.options,
                promotion_tag_swatch: productIterator.promotion_tag_swatch,
                badges_swatch: productIterator.badges_swatch,
              };

              if (
                productIterator.__typename === labels.lbl_product_type_bundle
              ) {
                obj.bundleOption = productIterator.items;
              }

              if (
                productIterator.__typename ===
                  labels.lbl_product_typeName_configurable &&
                productIterator.variants &&
                productIterator.variants.length > 0
              ) {
                obj.variantConfig = skudata && skudata.variantConfig;
                const variants = productIterator.variants.map((variant) => {
                  const {
                    product: { name, quantity, sku, stock_status, price_range },
                    attributes,
                  } = variant || {};
                  const variantObj = {
                    attributes: attributes,
                    product: {
                      name,
                      quantity,
                      sku,
                      stock_status,
                      price_range,
                    },
                  };
                  return variantObj;
                });
                obj.variants = variants;
              }

              data.push(obj);
            }
          });
      });
    return data;
  } else {
    return null;
  }
};

export const options = (arr, attr) => {
  if (isArrayNotEmpty(arr) && attr) {
    // let values = arr.find((val) => val.attribute_code === attr).values;
    // return values;
    return arr.find((val) => val.attribute_code === attr).values;
  }
};

export const configurableOptions = (arr) => {
  if (isArrayNotEmpty(arr)) {
    return arr.map((val) => val.attribute_code);
  }
};

export const myFunction = (code, label, robj) => {
  robj[code] = label;
  return robj;
};

export const replaceUnderScore = (text) =>
  text
    .toString()
    .replace(/_/g, " ")
    .toLowerCase()
    .split(" ")
    .map((string) => string.charAt(0).toUpperCase() + string.substring(1))
    .join(" ");

export const getSelectedVariant = (variants, selectedOption) => {
  let selected;
  if (isArrayNotEmpty(variants) && selectedOption) {
    variants.find((variant) => {
      let selectedVariantValues = [];
      Object.entries(selectedOption).forEach((entry) => {
        const matched = variant.attributes.filter(
          (attr) => attr.code == entry[0] && attr.label == entry[1]
        );
        if (matched.length) {
          selectedVariantValues.push(matched[0]?.label);
        } else {
          selectedVariantValues.push(null);
        }
      });
      if (
        selectedVariantValues.length === Object.values(selectedOption).length &&
        JSON.stringify(selectedVariantValues) ===
          JSON.stringify(Object.values(selectedOption))
      ) {
        selected = variant;
      }
    });
    return selected;
  } else {
    return null;
  }
};

export const getLabel = (conFigOptionsArr, key) => {
  let headingObj;
  if (isArrayNotEmpty(conFigOptionsArr) && isArrayNotEmpty(key)) {
    headingObj = conFigOptionsArr.find(
      (config) => config.attribute_code === key[0]
    );
    return headingObj && headingObj?.label;
  }
};

export const handlePageSection = (index, breadcrumbItems) => {
  if (
    breadcrumbItems?.length >= index &&
    breadcrumbItems[breadcrumbItems?.length - index]?.label
  ) {
    return breadcrumbItems[breadcrumbItems?.length - index]?.label;
  }
  return "";
};

export const dynamicPageSection = (index, dynamicRoute) => {
  let dynamicBreadCrumbs = Object.keys(dynamicRoute)
    ? Object.keys(dynamicRoute)
    : [];

  if (dynamicBreadCrumbs.length > 0 && dynamicBreadCrumbs.length >= index) {
    return dynamicBreadCrumbs[dynamicBreadCrumbs.length - index];
  }
  return "";
};

export const africaCountryCode = (num) => {
  if (num && num.slice(0, 2) == countryCode) {
    return true;
  } else {
    return false;
  }
};

export const appendCountryCode = (num) => {
  if (!africaCountryCode(num)) {
    return countryCode + num.slice(1);
  } else {
    return num;
  }
};

export const removeCountryCode = (num) => {
  return "0" + num.slice(2);
};

export const convertInToObject = (arr) => {
  let data = [];
  if (arr) {
    let len = arr.length;
    for (let i = 0; i < len; i++) {
      data.push({ name: arr[i], id: arr[i] });
    }
  }
  return data;
};

export const replaceDropdownKeys = (arr, f_key, l_key, type) => {
  let len = arr.length;
  for (let i = 0; i < len; i++) {
    if (type == "country") {
      arr[i].id = arr[i][f_key] + "-" + arr[i][l_key];
      arr[i].name = capitalizeFirstLetter(arr[i][f_key]);
    } else if (type === "accountType") {
      arr[i].id = [i + 1] + "-" + arr[i][l_key];
    } else if (!("id" in arr[i])) {
      arr[i].id = arr[i][l_key];
      delete arr[i][l_key];
    }

    if (type === "occupations") {
      arr[i].name = capitalizeFirstLetter(arr[i][f_key]);
    } else if (!("name" in arr[i]) && !("label" in arr[i])) {
      arr[i].name = arr[i][f_key];
      delete arr[i][f_key];
    }
  }
  return arr;
};

export function getAge(dob) {
  const dOB = dob.split(" / ").join("");
  const year = Number(dOB.substr(4, 4));
  const month = Number(dOB.substr(2, 2)) - 1;
  const day = Number(dOB.substr(0, 2));
  const today = new Date();
  let age = today.getFullYear() - year;
  if (
    today.getMonth() < month ||
    (today.getMonth() == month && today.getDate() < day)
  ) {
    age--;
  }
  return age;
}

export const addAutoSlash = (value) => {
  if (/\D\/$/.test(value)) value = value.substr(0, value.length - 3);

  var values = value.split("/").map(function (v) {
    return v.replace(/\D/g, "");
  });

  if (values[0]) {
    values[0] = checkValue(values[0], 31, values[1] ? true : false);
  }
  if (values[1]) {
    values[1] = checkValue(values[1], 12, values[2] ? true : false);
  }

  var output = values.map(function (v, i) {
    //return v.length == 2 && i < 2 ? v + " / " : v;
    if (v.length == 2 && i < 2) {
      return v + " / ";
    } else if (v.length == 1 && i < 2 && values[i + 1]) {
      return v + " / ";
    } else {
      return v;
    }
  });

  return output.join("").substr(0, 14);
};

export function checkValue(str, max, addZero) {
  if (str.charAt(0) !== "0" || str == "00" || addZero) {
    var num = parseInt(str);

    if (addZero && str.length == 1 && num !== 0) {
      str = num.toString();
    } else if (isNaN(num) || num <= 0 || num > max) {
      num = 1;
      str =
        num > parseInt(max.toString().charAt(0)) && num.toString().length == 1
          ? "0" + num
          : num.toString();
    }
  }
  return str;
}

export const addOrdinalSuffix = (num) => {
  const int = parseInt(num),
    digits = [int % 10, int % 100],
    ordinals = ["st", "nd", "rd", "th"],
    oPattern = [1, 2, 3, 4],
    tPattern = [11, 12, 13, 14, 15, 16, 17, 18, 19];
  return oPattern.includes(digits[0]) && !tPattern.includes(digits[1])
    ? int + ordinals[digits[0] - 1]
    : int + ordinals[3];
};

export const getValueLabel = (val, arr) => {
  let valueLabel = arr.find((item) => item.id == val);
  return valueLabel?.name
    ? valueLabel.name
    : valueLabel?.label
    ? valueLabel.label
    : "";
};

export const getTotalDuration = (str) => {
  let period = "-";
  if (str && str !== "") {
    let year = str.toString().slice(0, 2);
    let month = str.toString().slice(5, 7);
    period = Number(year) + " years, " + Number(month) + " months";
  }
  return period;
};

export const capitalizeFirstLetter = (str) => {
  // converting first letter to uppercase
  const lstr = str.toLowerCase(),
    capitalized = lstr.toLowerCase().charAt(0).toUpperCase() + lstr.slice(1);
  return capitalized;
};

export const numRegEx = RegExp(/^[0-9]*$/);
export const regName = RegExp(/^[a-zA-Z]+ [a-zA-Z]+$/);
export const charRegExpForName = RegExp(/^[a-zA-Z ]+$/);
export const charRegExp = RegExp(/^[a-zA-Z]+$/);
export const dateRegex = RegExp(
  /^([0][1-9]|[12][0-9]|3[01])[\s][\/][\s]([0][1-9]|1[012])[\s][\/][\s](19|20)\d{2}$/
);
export const durationRegex = RegExp(
  /^([0][1-9]|[1-9][0-9])[\s][\/][\s]([0][1-9]|1[011])$/
);
export const currencyRegex = RegExp(/^[1-9]\d*$/);
export const nameRegex = RegExp(/^[a-zA-Z\s]*$/);

export const charSpaceRegExp = RegExp(/^[a-z][a-z\s]*$/);
export const streetNameRegEx = RegExp(/^[a-zA-Z0-9_ ]*$/);
export const cellPhoneRegEx = RegExp(/^0|27[0-9]*$/);
export const emailRegEx = RegExp(
  /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
);

export const matchWordInString = (str, word) => {
  if (str && str !== "" && word && word !== "") {
    var pattern = RegExp("\\b(" + word + ")\\b", "g");
    var match = pattern.test(str);

    return match;
  } else {
    return false;
  }
};

export const preValidationEligible = (statusCode) => {
  let status = false;

  switch (statusCode) {
    case "PREVALIDATION_ELIGIBLE":
    case "PREVALIDATION_EXPIRED":
    case "PREVALIDATION_ERRORED":
    case "PREVALIDATION_CANCELED":
    case "PREVALIDATION_APPROVED":
    case "PREVALIDATION_APPROVED_WITH_CONDITIONS":
      status = true;
      break;
  }
  return status;
};

export const preValidationUpgradeEligible = (statusCode) => {
  let status = false;

  switch (statusCode) {
    case "PREVALIDATION_ELIGIBLE":
      status = true;
      break;
  }
  return status;
};

export const getPreValidationErrorType = (statusCode) => {
  let type = null;
  switch (statusCode) {
    case "PREVALIDATION_UNAUTHORIZED":
      type = "technical error";
      break;
    case "PREVALIDATION_NOT_ELIGIBLE":
      type = "not eligibile";
      break;
    case "PREVALIDATION_NOT_ELIGIBLE_DECLINED_LAST_30_DAY":
    case "PREVALIDATION_NOT_ELIGIBLE_PENDING_LAST_30_DAY":
      type = "30 days";
      break;
    case "PREVALIDATION_NOT_ELIGIBLE_DECLINED_LAST_60_DAY":
    case "PREVALIDATION_NOT_ELIGIBLE_PENDING_LAST_60_DAY":
      type = "60 days";
      break;
    case "LETSGETSTARTED_LEGACY":
    case "PREVALIDATION_NOT_ELIGIBLE_NOT_ONLINE":
      type = "legacy";
      break;
    case "PREVALIDATION_ORDER_EXISTS":
      type = "siebel";
      break;
    case "PREVALIDATION_NOT_ELIGIBLE_PENDED":
      type = "pended";
      break;
    case "PREVALIDATION_NOT_ELIGIBLE_REFERRED":
      type = "referred";
      break;
    case "PREVALIDATION_NOT_ELIGIBLE_DECLINED":
      type = "declined";
      break;
    case "PREVALIDATION_NOT_ELIGIBLE_NOT_AFFORDABLE":
      type = "approved with conditions";
      break;
    case "PREVALIDATION_PREVIOUS_ACTIVE_CREDIT_VET":
      type = "active credit vet";
      break;
    case "PREVALIDATION_NOT_ELIGIBLE_ACCOUNT_IN_ARREARS":
      type = "account in arrears";
      break;
    default:
      type = typeof statusCode === "string"
        ? statusCode.trim().toLowerCase().replace("prevalidation_", "").replace(/_/g, " ")
        : null;
      break;
  }
  return type;
};

export const titleCase = (str) =>
  str.replace(/(^|\s)\S/g, (t) => t.toUpperCase());

export const titleCaseFirstLetterOfString = (str) => {
  var splitStr = str.toLowerCase().split(" ");
  for (var i = 0; i < splitStr.length; i++) {
    splitStr[i] =
      splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  return splitStr.join(" ");
};

export const toDesignation = (str) =>
  (str || "")
    .toString()
    .replace(/^\s|\s$/, "")
    .replace(/\s+/g, "-")
    .toLowerCase();

export const debounce = (func, timeout = 300) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
};

export const isValueSelected = (dataArr, selected, key, field) => {
  let isPresent = -1;
  if (dataArr && dataArr[key] && dataArr[key].length > 0) {
    isPresent = dataArr[key].findIndex(
      (item) => item[field || "value"] === selected[field || "value"]
    );
  }
  return isPresent !== -1;
};

export const manipulateFilter = (flag, data, selected, key, field) => {
  let dataArr = data && data[key] ? [...data[key]] : [];
  if (flag) {
    dataArr.filter(
      (item) => item[field || "label"] === selected[field || "label"]
    ).length === 0
      ? dataArr.push(selected)
      : dataArr;
  } else {
    dataArr.filter((item, index) => {
      if (item[field || "label"] === selected[field || "label"]) {
        dataArr.splice(index, 1);
      }
    });
  }
  return dataArr;
};

export const getCartGrandTotal = (cartDetails) => {
  if (cartDetails) {
    if (cartDetails?.shipping_address?.[0]?.selected_shipping_method) {
      return `R${formatNumbersWithComma(
        parseFloat(cartDetails?.prices?.grand_total?.value)
      )}`;
    } else {
      if (cartDetails?.selected_shipping_method) {
        return `R${formatNumbersWithComma(
          parseFloat(cartDetails?.prices?.grand_total?.value)
        )}`;
      }
    }

    if (
      !cartDetails?.shipping_address?.[0]?.selected_shipping_method &&
      cartDetails?.prices?.grand_total?.value == 0
    ) {
      if (
        cartDetails?.shippingFeeCalculate?.shipping_fee != 0 &&
        cartDetails?.shippingFeeCalculate?.shipping_fee != null
      ) {
        return `R${formatNumbersWithComma(
          parseFloat(cartDetails?.shippingFeeCalculate?.shipping_fee)
        )}`;
      }
      return `R${formatNumbersWithComma(
        parseFloat(cartDetails?.prices?.grand_total?.value)
      )}`;
    }

    if (
      cartDetails?.shippingFeeCalculate?.shipping_fee &&
      cartDetails?.shippingFeeCalculate?.shipping_fee != null &&
      cartDetails?.prices?.grand_total?.value &&
      cartDetails?.prices?.grand_total?.value != null
    ) {
      return `R${formatNumbersWithComma(
        parseFloat(cartDetails?.shippingFeeCalculate?.shipping_fee) +
          parseFloat(cartDetails.prices?.grand_total?.value)
      )}`;
    }

    return null;
  }
  return null;
};

export const addAutoSlashToPeriod = (value, blur, str) => {
  let output = value;
  if (!RegExp(/^[0-9/]+$/).test(value)) {
    output = value.replace(/\D/g, "");
  }
  if (blur && value) {
    if (value) {
      output = Number(value.replace(/\D/g, "")) + " " + str;
    } else {
      output = value;
    }
  } else {
    if (value) {
      output = Number(value.replace(/\D/g, ""));
    } else {
      output = value;
    }
  }
  return output;
};

export const checkYearAndMonthFormat = (years, months, isRequired) => {
  let year = parseInt(years.toString().slice(0, 2)),
    month = parseInt(months.toString().slice(0, 2)),
    error = "";
  if (!isRequired) {
    if (isNaN(month) != "" || isNaN(year) != "" || month > 11) {
      error = true;
    } else {
      error = false;
    }
  } else {
    if (
      isNaN(month) != "" ||
      isNaN(year) != "" ||
      (year <= 0 && month <= 0) ||
      month > 11
    ) {
      error = true;
    } else {
      error = false;
    }
  }
  return error;
};

export const getCustomizableOptions = (optionId, valueString) => {
  if (optionId && valueString) {
    return [
      {
        id: optionId,
        value_string: valueString.toString(),
      },
    ];
  } else {
    return [];
  }
};

export const generateFormURL = (url, leadType, btnType, preferenceId) => {
  let newUrl = url;

  if (preferenceId) {
    newUrl = getPreferenceRoutingUrl(preferenceId);
  }

  if (newUrl.includes("forms/ecommerce")) {
    if (btnType && btnType == "lead") {
      return preferenceId == ("all-above" || "call-me-back")
        ? `${newUrl}?bucket=${leadType}&cartType=multicart&preferenceId=${preferenceId}`
        : `${newUrl}?bucket=${leadType}`;
    } else {
      return newUrl;
    }
  } else {
    return newUrl;
  }
};

export const getProductImageUrl = (item, image_type, no_image) => {
  return item?.[image_type]?.url &&
    item?.[image_type]?.url !== null &&
    !item?.[image_type].url.includes(no_image)
    ? item?.[image_type]?.url
    : item?.primary_product_image && item?.primary_product_image !== null
      ? item?.primary_product_image
      : item?.[image_type]?.url;
};

export const getOrderProductImageUrl = (item, image_type, no_image) => {
  return item?.[image_type] &&
    item?.[image_type].length &&
    !item?.[image_type][0].includes(no_image)
    ? item?.[image_type]
    : item?.primary_product_image && item?.primary_product_image?.length
    ? item?.primary_product_image
    : item?.[image_type];
};

export const getPreferenceRoutingUrl = (id) => {
  let url = "/forms/ecommerce";
  switch (id) {
    case "call-me-back":
      url = "/forms/ecommerce";
      break;
    case "once-off":
      url = "/checkout";
      break;
    case "all-above":
      url = "/forms/ecommerce";
      break;
    case "select-another-deal-need-once-off":
    case "select-another-deal-dont-need-once-off":
      url = "/deals";
      break;
    case "check-once-off-only":
      url = "/checkout";
      break;
  }
  return url;
};

export const getClearCartQuery = (cartItemsIds) => {
  let query = "";
  let cartId = getCookieValue("cart_id");

  for (const id of cartItemsIds) {
    query += `
  removeItem${id}: removeItemFromCart(
     input: {
       cart_id: "${cartId}",
       cart_item_id: ${id}
     }
   )
    {
   cart {
     items {
       id
     }
   }
  }`;
  }
  query = "mutation {" + query + "}";

  return query;
};

export const getCustomerPositionAsync = () =>
  new Promise((resolve, reject) => {
    let resultData = { error: "", result: { latitude: "", longitude: "" } };

    function success(position) {
      resultData.result.latitude = position.coords.latitude;
      resultData.result.longitude = position.coords.longitude;
      resolve(resultData);
    }

    function error() {
      resultData.error = "Unable to retrieve your location";
      reject(resultData);
    }

    if (!navigator.geolocation) {
      resultData.error = "Geolocation is not supported by your browser";
    } else {
      navigator.geolocation.getCurrentPosition(success, error);
    }
  });
/**
 *This function is used to get the age of the customer
 */
export const getDateOfBirth = (dob) => {
  let formattedDate;
  const today = new Date();
  formattedDate = dob.split("/");
  formattedDate =
    formattedDate[1] + "/" + formattedDate[0] + "/" + formattedDate[2];
  const birthDate = new Date(formattedDate);
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};

export const checkPreOrder = (resultData) => {
  let preOrderFound = resultData.filter(
    (item) =>
      item?.product?.badges_label &&
      item?.product?.badges_label
        .toLowerCase()
        .indexOf(types.TYPE_PREORDER.toLowerCase()) > -1
  );
  if (preOrderFound && preOrderFound.length > 0) {
    return true;
  }

  return false;
};

export const isValidJSON = (jsonStr) => {
  try {
    JSON.parse(jsonStr);
  } catch (e) {
    return false;
  }

  return true;
}
